export default {
    MoveInRedirectButton: 'login-page-move-in-redirect-button',
    Login: {
        SwitchClientTypeButton: 'switch_clientType_button',
        confirmLoginButton: 'confirm_login_button'
    },
    Logout: {
        Logout: 'logout_main-container',
        Button: 'logout_logout-button'
    }
};
